const initForms = () => {
    document.addEventListener("click", (e) => {
        if(e.target.closest("[data-custom-form-open]")) {
            const floatingButton = document.querySelector(".globo-form .floating-button");
            if(floatingButton) floatingButton.click()
        }
    })
}

document.addEventListener("DOMContentLoaded", () => {
    initForms();
})